import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpModule } from '@angular/http';

import { LoginComponent } from '../../components/login/login.component';
import { LoginService } from './login.service';
import { LoginRoutingModule } from './login-routing.module';
import { LoaderService } from './../../loader/loader.service';
import { SharedModule } from '../../shared/shared.module';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { FooterComponent } from "../../footer/footer.component";
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    InputTextModule,
    SharedModule
    // HttpModule
    ,
    FooterComponent
],
  declarations: [
    LoginComponent
  ],
  providers: [LoginService, LoaderService,AssistBotService],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class LoginModule { }
